import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { HydrationActions } from '@app/resources/ngrx/actions';
import { RootState } from '@app/resources/ngrx/states';

@Injectable()
export class HydrationEffects implements OnInitEffects {
  private readonly action$ = inject(Actions);
  private readonly store = inject(Store<RootState>);

  hydrate$ = createEffect(() =>
    this.action$.pipe(
      ofType(HydrationActions.hydrate),
      map(() => {
        const storageValue = localStorage.getItem('state');
        if (storageValue) {
          try {
            const state = JSON.parse(storageValue);
            return HydrationActions.hydrateSuccess({ state });
          } catch {
            localStorage.removeItem('state');
          }
        }
        return HydrationActions.hydrateError();
      })
    )
  );

  clear$ = createEffect(() =>
    this.action$.pipe(
      ofType(HydrationActions.clear),
      map(() => {
        const storageValue = localStorage.getItem('state');
        if (storageValue) {
          localStorage.removeItem('state');
        }

        return HydrationActions.hydrateSuccess({ state: null });
      })
    )
  );

  serialize$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(HydrationActions.hydrateSuccess, HydrationActions.hydrateError),
        switchMap(() => this.store),
        distinctUntilChanged(),
        tap((state) => {
          const { router: _, ...filteredState } = state;
          localStorage.setItem('state', JSON.stringify(filteredState));
        })
      ),
    { dispatch: false }
  );

  ngrxOnInitEffects(): Action {
    return HydrationActions.hydrate();
  }
}
